import axiosInstance from "../service/axiosInterceptor";
const user = JSON.parse(localStorage.getItem('user'));
export const updateSignUpQuestions = async (selections) => {
    try {
        const response = await axiosInstance.put(
            `/user/sign-up-questions/${user.userId}`,
            { userSignUpQuestions: selections }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating sign-up questions:", error);
        throw error;
    }
};


export async function updateUser(id, userData) {
    try {
        const response = await axiosInstance.put(`/user/${id}`, userData);
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error);
        throw error;
    }
}


export const fetchUserById = async (userId) => {
    try {
        const response = await axiosInstance.get(`/user/${userId}`);
        return response.data; // Return the parsed JSON response
    } catch (error) {
        console.error(`Error fetching user with ID ${userId}:`, error);
        throw error;
    }
};

export const uploadProfilePicture = async (formData, userId) => {
    try {
        const response = await axiosInstance.post(`/user/profile-picture/${userId}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Specify content type for file uploads
            },
        });

        if (!response.data.success) {
            throw new Error(response.data.message || "Error uploading profile picture");
        }

        return response.data;
    } catch (error) {
        console.error("Error uploading profile picture:", error);
        throw error;
    }
};